import React from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

// Only show confetti when animations are not suppressed by the user or OS.
function shouldShowConfetti() {
  try {
    return document.documentElement.getAttribute('data-a11y-motion') !== 'reduce';
  } catch {
    return true;
  }
}

export default function FormProgressBar({ progress, showConfetti }) {
  const roundedProgress = Math.round(progress);

  return (
    <div id="form-progress-bar-container" className="flex justify-between items-center p-2 md:p-4">
      <div className="w-full self-stretch py-1.5 justify-start items-center gap-3 inline-flex">
        <div
          className="flex-grow h-2 relative rounded-lg bg-gray-200"
          role="progressbar"
          aria-valuenow={roundedProgress}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Form progress: ${roundedProgress}%`}
        >
          <div
            className="absolute top-0 left-0 h-2 rounded-full transition-all duration-300 bg-green-500"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div aria-hidden="true" className="text-slate-700 text-sm font-medium leading-tight">
          {roundedProgress}%
        </div>
      </div>
      {showConfetti && shouldShowConfetti() && (
        <ConfettiExplosion particleCount={25} force={0.4} duration={2200} width={400} />
      )}
    </div>
  );
}